require 'angular'

app = angular.module('workflow.app')

state = {}

app.config ($stateProvider, $urlRouterProvider) ->

  # The main inheritance tree for the workflow project
  # Misses the single states off for simplicity
  #
  # Project
  #     Workflow
  #         Step
  #           Iteration
  #             Facets
  #               Worker
  #               Overview
  #             Unsearched
  #           Custom Step
  #           Findings
  #           Support

  # --------------------------------
  # ======  Homepage Overview ======
  # --------------------------------
  state.root =
    name: 'root'
    abstract: true
    controller: 'RootController'
    template: require('./components/Root/root.html')
    resolve: require('./components/Root/RootResolve')

  state.start =
    name: 'start'
    title: 'Reports'
    parent: state.root
    url: '/start?offset&limit&showArchived&name&owner&country'
    template: require('./components/Reports/reports.html')
    controller: 'ReportsController'
    resolve: require('./components/Reports/ReportsResolve')

  # --------------------------------
  # ===========  Project ===========
  # --------------------------------

  state.project_manipulate =
    name: 'project-manipulate'
    parent: state.root
    abstract: true
    template: '<div ui-view=""></div>'
    controller: 'ProjectManipulateController'
    resolve: require('./components/ProjectNew/ProjectManipulateResolve')

  state.project_new =
    name: 'project-new'
    title: 'New project'
    parent: state.project_manipulate
    url: '/project-new/?entity&heimdall_alert&name&entity_type&template&country&adverse_terms_id'
    template: require('./components/ProjectNew/project-manipulate.html')

  state.project_clone =
    name: 'project-clone'
    title: 'Clone project'
    parent: state.project_manipulate
    url: '/project-clone/:projectId'
    template: require('./components/ProjectNew/project-manipulate.html')
    controller: 'ProjectCloneController'
    resolve: require('./components/ProjectNew/ProjectCloneResolve')

  state.project_delta =
    name: 'project-delta'
    title: 'Run delta project'
    parent: state.project_manipulate
    url: '/project-delta/:projectId'
    template: require('./components/ProjectNew/project-manipulate.html')
    controller: 'ProjectDeltaController'
    resolve: require('./components/ProjectNew/ProjectCloneResolve')

  state.project_edit =
    name: 'project-edit'
    title: 'Edit project'
    parent: state.project_manipulate
    url: '/project-edit/:projectId?entity'
    template: require('./components/ProjectNew/project-manipulate.html')
    controller: 'ProjectEditController'
    resolve: require('./components/ProjectNew/ProjectEditResolve')

  state.view_exports =
    name: 'view-exports'
    title: 'View exports'
    parent: state.project_manipulate
    url: '/view-exports/:projectId'
    template: require('./components/Exports/exports.html')
    controller: 'ExportsController'
    resolve: require('./components/Exports/ExportsResolve')

  # NOTE: Changes to the `url` will have to be reflected in `models.py`.
  # The `get_audit_trail_link` method returns a string that is based on the
  # frontend URL structure (hardcoded).

  state.project =
    name: 'project'
    title: '{{project.name}} - {{workflow.name}}'
    parent: state.root
    # Changes to the URL must be reflected in `models.py`
    url: '/project/{projectId:int}'
    resolve: require('./components/Project/ProjectResolve')
    controller: 'ProjectController'
    template: '<div ui-view=""></div>'
  state.project_manual =
    name: 'project.manual'
    title: '{{project.name}} - {{workflow.name}}'
    parent: state.project
    url: '/manual'
    resolve: require('./components/ProjectManual/ProjectManualResolve')
    controller: 'ProjectManualController'
    template: require('./components/ProjectManual/project-manual.html')
  state.project_workflow =
    name: 'project.workflow'
    parent: state.project
    # Changes to the URL must be reflected in `models.py`
    url: '/workflow/:workflowId'
    resolve: require('./components/Project/ProjectWorkflowResolve')
    controller: 'ProjectWorkflowController'
    template: '<div ui-view=""></div>'
  state.project_step =
    name: 'project.workflow.step'
    title: '{{project.name}} - {{workflow.name}} - {{step.name}}'
    parent: state.project_workflow
    # Changes to the URL must be reflected in `models.py`
    url: '/:workflowStepId'
    resolve: require('./components/Project/Step/ProjectStepResolve')
    controller: 'ProjectStepController'
    template: require('./components/Project/Step/project-step.html')

  state.project_export =
    name: 'project.export'
    title: '{{project.name}} - export'
    parent: state.project
    url: '/export'
    template: require('./components/ProjectExport/project-export.html')
    controller: 'ProjectExportController'
    resolve: require('./components/ProjectExport/ProjectExportResolve')

  # --------------------------------
  # ===========  Search ============
  # --------------------------------
  search_title = '{{project.name}} - {{workflow.name}} - {{step.name}} - Search results'

  state.iteration =
    # fetches the workers of this search iteration
    # switch workers.length:
    #  0 - to unsearched
    #  1 - to worker
    #  > 1 - to facets
    name: 'project.workflow.step.iteration'
    title: search_title
    parent: state.project_step
    # Changes to the URL must be reflected in `models.py`
    url: '/iter/:iterationId'
    controller: 'SearchController'
    template: require('./components/Project/Step/Search/search.html')
    resolve: require('./components/Project/Step/Search/SearchResolve')

  state.iteration_facet =
    # shows the facets but loads no data
    name: 'project.workflow.step.iteration.facets'
    title: search_title
    parent: state.iteration
    url: '/facets'
    controller: 'FacetsController'
    template: require('./components/Project/Step/Search/facets.html')

  state.iteration_facet_worker =
    # loads the results of the worker and displays them inside the facets
    name: 'project.workflow.step.iteration.facets.worker'
    title: search_title
    parent: state.iteration_facet
    url: '/worker/:workerId?offset&limit&goToSource'
    template: require('./components/Project/Step/Search/Worker/worker.html')
    controller: 'WorkerController'
    resolve: require('./components/Project/Step/Search/Worker/WorkerResolve')

  state.iteration_facet_overview =
    # loads no data but show the overview
    name: 'project.workflow.step.iteration.facets.overview'
    title: search_title
    parent: state.iteration_facet
    url: '/overview'
    template: require('./components/Project/Step/Search/facets-overview.html')

  state.iteration_unsearched =
    # list the unsearched sources of the step
    name: 'project.workflow.step.iteration.facets.manualchecks'
    title: '{{project.name}} - {{workflow.name}} - {{step.name}} - Unsearched sources'
    parent: state.iteration_facet
    url: '/manual'
    controller: 'UnsearchedSourcesController'
    template: require('./components/Project/Step/Search/ManualChecks/unsearched-sources.html')

  # --------------------------------
  # ========  Custom step ==========
  # --------------------------------

  state.custom_step =
    name: 'project.workflow.step.custom'
    title: search_title
    parent: state.project_step
    url: '/custom'
    template: require('./components/Project/Step/Custom/custom-step.html')
    controller: 'CustomStepController'
    resolve: require('./components/Project/Step/Custom/CustomStepResolve')

  # --------------------------------
  # ========  Step finding =========
  # --------------------------------

  state.step_findings =
    name: 'project.workflow.step.findings'
    title: search_title
    parent: state.project_step
    url: '/findings'
    template: require('./components/Project/Step/Findings/step-findings.html')
    controller: 'StepFindingsController'

  # --------------------------------
  # ===========  Support ===========
  # --------------------------------
  state.support_list =
    name: 'support-list'
    title: 'Support'
    parent: state.root
    url: '/support/list/'
    template: require('./components/SupportList/support-list.html')
    controller: 'SupportListController'
    resolve: require('./components/SupportList/SupportListResolve')

  state.support_thread =
    name: 'project.workflow.step.support'
    title: 'Support - {{request.subject}}'
    parent: state.iteration_facet
    url: '/support/:supportId/'
    template: require('./components/Project/Step/SupportThread/support-thread.html')
    controller: 'SupportThreadController'
    resolve: require('./components/Project/Step/SupportThread/SupportThreadResolve')

  # --------------------------------
  # =========  Preferences =========
  # --------------------------------
  state.preferences_workflow_list =
    name: 'preferences-workflow-list'
    title: 'Preferences - List workflows'
    parent: state.root
    url: '/preferences/workflow/list/'
    template: require('./components/PreferencesWorkflowList/preferences-workflow-list.html')
    resolve: require('./components/PreferencesWorkflowList/PreferencesWorkflowListResolve')
    controller: 'PreferencesWorkflowListController'
  state.preferences_workflow_edit =
    name: 'preferences-workflow-edit'
    title: 'Preferences - {{workflowTemplate.name}}'
    parent: state.root
    url: '/preferences/workflow/edit/:workflowId?'
    template: require('./components/PreferencesWorkflowEdit/preferences-workflow-edit.html')
    resolve: require('./components/PreferencesWorkflowEdit/PreferencesWorkflowEditResolve')
    controller: 'PreferencesWorkflowEditController'
  state.action_log =
    name: 'action-log'
    title: 'View audit trail'
    parent: state.root
    url: '/action-log/:projectId'
    template: require('./components/ActionLog/action-log.html')
    resolve: require('./components/ActionLog/ActionLogResolve')
    controller: 'ActionLogController'
  state.action_log_entity =
    name: 'action-log-entity'
    title: 'View audit trail'
    parent: state.root
    url: '/action-log-entity/:entityId'
    template: require('./components/ActionLog/action-log.html')
    resolve: require('./components/ActionLog/ActionLogResolve')
    controller: 'ActionLogController'
  state.audit_trail =
    name: 'audit_trail'
    title: 'View audit trail'
    parent: state.root
    url: '/audit-trail/:projectId/?start&page&user&event'
    template: require('./components/AuditTrail/audit-trail.html')
    resolve: require('./components/AuditTrail/AuditTrailResolve')
    controller: 'AuditTrailController'
  state.entity =
    name: 'entity'
    title: 'View entities'
    parent: state.root
    url: '/entity/'
    template: require('./components/Entity/entity-list.html')
    resolve: require('./components/Entity/EntityListResolve')
    controller: 'EntityListController'
  state.entity_profile =
    name: 'entity-profile'
    title: 'Entity profile'
    parent: state.root
    url: '/entity/:entityId'
    template: require('./components/Entity/Profile/entity.html')
    resolve: require('./components/Entity/Profile/EntityResolve')
    controller: 'EntityController'
  state.adverse_terms =
    name: 'adverse-terms'
    title: 'Adverse terms'
    parent: state.root
    url: '/adverseterms/list/'
    template: require('./components/AdverseTerms/adverse-terms.html')
    resolve: require('./components/AdverseTerms/AdverseTermsResolve')
    controller: 'AdverseTermsController'
  state.edit_adverse_terms =
    name: 'edit-adverse-terms'
    title: 'Adverse terms'
    parent: state.root
    url: '/adverseterms/edit/:adverseId?'
    template: require('./components/AdverseTerms/edit-adverse-terms.html')
    resolve: require('./components/AdverseTerms/EditAdverseTermsResolve')
    controller: 'EditAdverseTermsController'

  state.sources =
    name: 'sources'
    title: 'Sources'
    parent: state.root
    url: '/sources/'
    template: require('./components/Sources/sources.html')
    resolve: require('./components/Sources/SourcesResolve')
    controller: 'SourcesController'
  state.country_sources =
    name: 'country-sources'
    title: 'Sources'
    parent: state.root
    url: '/sources/:isoCode?start&category&page'
    template: require('./components/Sources/country-sources.html')
    resolve: require('./components/Sources/CountrySourcesResolve')
    controller: 'CountrySourcesController'

  state.monitoring =
    name: 'monitoring'
    title: 'Monitoring'
    parent: state.root
    url: '/monitoring/overview'
    template: require('./components/Monitoring/monitoring-list.html')
    resolve: require('./components/Monitoring/MonitoringResolve')
    controller: 'MonitoringController'
  state.subject =
    name: 'subject'
    title: 'Subject'
    parent: state.root
    url: '/monitoring/subject/{subjectId:int}'
    template: require('./components/Monitoring/subject.html')
    resolve: require('./components/Monitoring/SubjectResolve')
    controller: 'SubjectController'
  state.alerts_subject =
    name: 'subject.alerts'
    title: '{{ getSubjectName(subject) }} - Subject'
    parent: state.subject
    url: '/alerts'
    template: require('./components/Monitoring/subject-alerts.html')
    resolve: require('./components/Monitoring/SubjectAlertsResolve')
    controller: 'SubjectAlertsController'
  state.subject_alert =
    name: 'subject.alert'
    title: '{{ getFullName(alert) }} - Alert'
    parent: state.subject
    url: '/alert/{alertId:int}'
    template: require('./components/Monitoring/Alert/alert-detail.html')
    resolve: require('./components/Monitoring/Alert/AlertResolve')
    controller: 'AlertController'
  state.edit_subject =
    name: 'subject.edit'
    title: '{{ getSubjectName(subject) }} - Edit Subject'
    parent: state.subject
    url: '/edit'
    template: require('./components/Monitoring/subject-edit.html')
    controller: 'SubjectEditController'
  state.new_subject =
    name: 'new_subject'
    title: 'New Subject'
    parent: state.root
    url: '/monitoring/subject/new'
    template: require('./components/Monitoring/subject-edit.html')
    controller: 'SubjectEditController'
    resolve: require('./components/Monitoring/SubjectNewResolve')

  # --------------------------------
  # ============  Login ============
  # --------------------------------
  state.login =
    name: 'not-logged-in'
    title: 'Please login'
    url: '/login/?previous_url&bad_permission'
    template: require('./components/Login/login.html')
    controller: 'LoginController'

  # --------------------------------
  # ========  Bulk Upload ==========
  # --------------------------------
  state.bulkupload =
    name: 'bulkupload'
    title: 'Bulk uploads'
    parent: state.root
    url: '/bulkupload/?page'
    template: require('./components/BulkUpload/bulk-upload.html')
    controller: 'BulkUploadController'
    resolve: require('./components/BulkUpload/BulkUploadResolve')

  # --------------------------------
  # ====  Bulk Upload Mappings =====
  # --------------------------------
  state.bulkuploadmappings =
    name: 'bulkuploadmappings'
    title: 'Bulk upload mappings'
    parent: state.root
    url: '/bulkuploadmappings/?page'
    template: require('./components/BulkUploadMappings/bulk-upload-mappings.html')
    controller: 'BulkUploadMappingsController'
    resolve: require('./components/BulkUploadMappings/BulkUploadMappingsResolve')

  state.edit_bulkuploadmapping =
    name: 'edit-bulkuploadmapping'
    title: 'Edit bulk upload mapping'
    parent: state.root
    url: '/bulkuploadmappings/edit/:bulkUploadMappingId'
    template: require('./components/BulkUploadMappings/MappingDetail/bulk-upload-mapping.html')
    controller: 'BulkUploadMappingController'
    resolve: require('./components/BulkUploadMappings/MappingDetail/BulkUploadMappingResolve')

  state.new_bulkuploadmapping =
    name: 'new-bulkuploadmapping'
    title: 'Add bulk upload mapping'
    parent: state.root
    url: '/bulkuploadmappings/new/'
    template: require('./components/BulkUploadMappings/MappingDetail/bulk-upload-mapping.html')
    controller: 'BulkUploadMappingController'
    resolve: require('./components/BulkUploadMappings/MappingDetail/BulkUploadMappingResolve')

  # --------------------------------
  # ============ Plugins ===========
  # --------------------------------

  state.plugins =
    name: 'integrations'
    title: 'Integrations'
    parent: state.root
    url: '/integrations'
    template: require('./components/Plugins/plugins.html')
    controller: 'PluginsController'
    resolve: require('./components/Plugins/PluginsResolve')

  state.manage_users =
    name: 'manage-users'
    title: 'Manage users'
    parent: state.root
    url: '/manage-users'
    template: require('./components/ManageUsers/manage-users.html')
    controller: 'ManageUsersController'
    resolve: require('./components/ManageUsers/ManageUsersResolve')

  state.user_preferences =
    name: 'user-preferences'
    title: 'User Preferences'
    parent: state.root
    url: '/preferences/user'
    template: require('./components/UserPreferences/user-preferences.html')
    controller: 'UserPreferencesController'
    resolve: require('./components/UserPreferences/UserPreferencesResolve')

  $stateProvider
    .state(state.root)
    .state(state.start)
    .state(state.project_manipulate)
    .state(state.project_new)
    .state(state.project_clone)
    .state(state.project_delta)
    .state(state.project_edit)
    .state(state.project_manual)
    .state(state.support_list)
    .state(state.preferences_workflow_list)
    .state(state.preferences_workflow_edit)
    .state(state.adverse_terms)
    .state(state.edit_adverse_terms)
    .state(state.action_log)
    .state(state.action_log_entity)
    .state(state.audit_trail)
    .state(state.entity)
    .state(state.entity_profile)
    .state(state.bulkupload)
    .state(state.bulkuploadmappings)
    .state(state.edit_bulkuploadmapping)
    .state(state.new_bulkuploadmapping)

    .state(state.project)
    .state(state.project_workflow)
    .state(state.project_step)
    .state(state.iteration)
    .state(state.iteration_facet)
    .state(state.iteration_facet_worker)
    .state(state.iteration_facet_overview)
    .state(state.iteration_unsearched)
    .state(state.custom_step)
    .state(state.step_findings)
    .state(state.sources)
    .state(state.country_sources)
    .state(state.monitoring)
    .state(state.subject)
    .state(state.alerts_subject)
    .state(state.subject_alert)
    .state(state.edit_subject)
    .state(state.new_subject)
    .state(state.support_thread)

    .state(state.project_export)
    .state(state.login)
    .state(state.plugins)
    .state(state.manage_users)
    .state(state.user_preferences)

    .state(state.view_exports)


  # for any unmatched url go this state
  $urlRouterProvider.otherwise("start")

app.config ($compileProvider) ->
  $compileProvider.debugInfoEnabled(false)

# Remove the loading spinner
app.config (cfpLoadingBarProvider) ->
  cfpLoadingBarProvider.includeSpinner = false

app.config ($uibTooltipProvider) ->
  $uibTooltipProvider.options
    popupDelay: 0

app.config ($httpProvider) ->
  if (!$httpProvider.defaults.headers.get)
    $httpProvider.defaults.headers.get = {}

  $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT'
  $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache'
  $httpProvider.defaults.headers.get['Pragma'] = 'no-cache'

app.config ($uibTooltipProvider) ->
  urlContains = ( subString ) ->
    if window.location.href.indexOf( subString ) is -1
      return false
    return true

  if urlContains( "disable_tooltips" )
    $uibTooltipProvider.setTriggers({'never': 'never'})
    $uibTooltipProvider.options( placement: 'bottom', popupDelay: 720, appendToBody: true, trigger: 'never' )
  else
    $uibTooltipProvider.options( placement: 'bottom', popupDelay: 720, appendToBody: true )

app.config ($httpProvider) ->
  $httpProvider.useApplyAsync(true)

module.exports = state: state
